import {createListenerMiddleware} from "@reduxjs/toolkit";

import {userComUserRegister} from "@pg-mono/user-com";

import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {loadFavouritesToStore} from "../../favorite/actions/load_favourites_to_store";
import {IRootState} from "../../store/store";
import {userSignInHit} from "../../tracking/algolytics_hits/user_sign_in_hit";
import {userSignUpHit} from "../../tracking/algolytics_hits/user_sign_up_hit";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {fetchUserUnsubscribeLink} from "../../user/api/fetch_user_unsubscribe_link";
import {getUserProfileApi} from "../../user/api/get_user_profile";
import {authSucceeded} from "../actions/auth_succeeded_event";
import {RegistrationFlowVariant, startRegistrationFlow} from "../state/registration_flow_slice";
import {nextStepVariantB} from "../state/registration_flow_variantB_slice";
import {AuthActionType} from "../types/AuthActionType";

/**
 * Listener for handling post-authentication actions (login or registration)
 * This should be triggered after user logs in or registers via login/register form
 * without use of kontomieszkaniowe.pl
 *
 * Use cases:
 * - Two-step application forms [CU-2t405gt]
 * - Hidden prices [CU-862j5xdx7]
 * - Registration after application sent
 */
export const afterAuthListener = createListenerMiddleware<IRootState>();

afterAuthListener.startListening({
    matcher: authSucceeded.match,
    effect: async (action, listenerApi) => {
        const authPayload = action.payload;

        const getUserProfileResult = await listenerApi.take(getUserProfileApi.endpoints.getUserProfile.matchFulfilled);
        const userProfile = getUserProfileResult?.[0]?.payload;
        const state = listenerApi.getState();

        if (!userProfile) {
            notifyBugsnag(new Error("getUserProfile does not return a valid data"), "Problem with getUserProfile");
            return;
        }

        try {
            const afterRegister = authPayload.type === AuthActionType.REGISTRATION;
            const currentViewType = state.viewType.current;

            // Send tracking hit
            (afterRegister ? userSignUpHit : userSignInHit)(authPayload.userSource, userProfile, currentViewType);

            // Handle registration flow (only for whitelisted sources)
            if (afterRegister) {
                const isSourceValidForShowRegistrationFlow = [UserSource.FAVOURITE_OFFER, UserSource.FAVOURITE_PROPERTY, UserSource.NAVIGATION].includes(
                    authPayload.userSource
                );

                if (isSourceValidForShowRegistrationFlow) {
                    const needsProfileCompletion = !userProfile.name || !userProfile.phone;

                    const isFavoritesSource = [UserSource.FAVOURITE_OFFER, UserSource.FAVOURITE_PROPERTY].includes(authPayload.userSource);
                    listenerApi.dispatch(
                        startRegistrationFlow({
                            needsProfileCompletion,
                            registrationMethod: authPayload.registrationMethod,
                            variant: isFavoritesSource ? RegistrationFlowVariant.FAVORITES : RegistrationFlowVariant.DEFAULT,
                            socialMediaType: authPayload.socialMediaType,
                            userSource: authPayload.userSource,
                            gtmSourceSection: authPayload.gtmSourceSection
                        })
                    );
                }

                const {email, uuid, email_marketing_consent, phone_marketing_consent} = userProfile;

                // Register user in user.com
                fetchUserUnsubscribeLink()
                    .then((response) => {
                        if (!response) {
                            return;
                        }

                        const {unsubscribe_url_rp, unsubscribe_url_gh} = response;
                        userComUserRegister(uuid, email, email_marketing_consent, phone_marketing_consent, unsubscribe_url_rp, unsubscribe_url_gh);
                    })
                    .catch((error) => {
                        notifyBugsnag(error, "Failed to fetch unsubscribe link for user.com registration");
                    });
            }

            // Load favourites
            await listenerApi.dispatch(loadFavouritesToStore());
        } catch (error) {
            notifyBugsnag(error, "Failed to process after auth actions", {
                authPayload
            });
        }

        // Logic for OngoingABTests.HIDE_PRICES_AND_REGISTER AB test
        const userNeedsProfileCompletion = (userProfile && (!userProfile.phone || !userProfile.name)) ?? false;

        listenerApi.dispatch(nextStepVariantB({userNeedsProfileCompletion}));
    }
});
import {createListenerMiddleware} from "@reduxjs/toolkit";

import {userComUserRegister} from "@pg-mono/user-com";

import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {loadFavouritesToStore} from "../../favorite/actions/load_favourites_to_store";
import {IRootState} from "../../store/store";
import {userSignInHit} from "../../tracking/algolytics_hits/user_sign_in_hit";
import {userSignUpHit} from "../../tracking/algolytics_hits/user_sign_up_hit";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {fetchUserUnsubscribeLink} from "../../user/api/fetch_user_unsubscribe_link";
import {getUserProfileApi} from "../../user/api/get_user_profile";
import {authSucceeded} from "../actions/auth_succeeded_event";
import {RegistrationFlowVariant, startRegistrationFlow} from "../state/registration_flow_slice";
import {nextStepVariantB} from "../state/registration_flow_variantB_slice";
import {AuthActionType} from "../types/AuthActionType";

/**
 * Listener for handling post-authentication actions (login or registration)
 * This should be triggered after user logs in or registers via login/register form
 * without use of kontomieszkaniowe.pl
 *
 * Use cases:
 * - Two-step application forms [CU-2t405gt]
 * - Hidden prices [CU-862j5xdx7]
 * - Registration after application sent
 */
export const afterAuthListener = createListenerMiddleware<IRootState>();

afterAuthListener.startListening({
    matcher: authSucceeded.match,
    effect: async (action, listenerApi) => {
        const authPayload = action.payload;

        const getUserProfileResult = await listenerApi.take(getUserProfileApi.endpoints.getUserProfile.matchFulfilled);
        const userProfile = getUserProfileResult?.[0]?.payload;
        const state = listenerApi.getState();

        if (!userProfile) {
            notifyBugsnag(new Error("getUserProfile does not return a valid data"), "Problem with getUserProfile");
            return;
        }

        try {
            const afterRegister = authPayload.type === AuthActionType.REGISTRATION;
            const currentViewType = state.viewType.current;

            // Send tracking hit
            (afterRegister ? userSignUpHit : userSignInHit)(authPayload.userSource, userProfile, currentViewType);

            // Handle registration flow (only for whitelisted sources)
            if (afterRegister) {
                const isSourceValidForShowRegistrationFlow = [UserSource.FAVOURITE_OFFER, UserSource.FAVOURITE_PROPERTY, UserSource.NAVIGATION].includes(
                    authPayload.userSource
                );

                if (isSourceValidForShowRegistrationFlow) {
                    const needsProfileCompletion = !userProfile.name || !userProfile.phone;

                    const isFavoritesSource = [UserSource.FAVOURITE_OFFER, UserSource.FAVOURITE_PROPERTY].includes(authPayload.userSource);
                    listenerApi.dispatch(
                        startRegistrationFlow({
                            needsProfileCompletion,
                            registrationMethod: authPayload.registrationMethod,
                            variant: isFavoritesSource ? RegistrationFlowVariant.FAVORITES : RegistrationFlowVariant.DEFAULT,
                            socialMediaType: authPayload.socialMediaType,
                            userSource: authPayload.userSource,
                            gtmSourceSection: authPayload.gtmSourceSection
                        })
                    );
                }

                const {email, uuid, email_marketing_consent, phone_marketing_consent} = userProfile;

                // Register user in user.com
                fetchUserUnsubscribeLink()
                    .then((response) => {
                        if (!response) {
                            return;
                        }

                        const {unsubscribe_url_rp, unsubscribe_url_gh} = response;
                        userComUserRegister(uuid, email, email_marketing_consent, phone_marketing_consent, unsubscribe_url_rp, unsubscribe_url_gh);
                    })
                    .catch((error) => {
                        notifyBugsnag(error, "Failed to fetch unsubscribe link for user.com registration");
                    });
            }

            // Load favourites
            await listenerApi.dispatch(loadFavouritesToStore());
        } catch (error) {
            notifyBugsnag(error, "Failed to process after auth actions", {
                authPayload
            });
        }

        // Logic for OngoingABTests.HIDE_PRICES_AND_REGISTER AB test
        const userNeedsProfileCompletion = (userProfile && (!userProfile.phone || !userProfile.name)) ?? false;

        listenerApi.dispatch(nextStepVariantB({userNeedsProfileCompletion}));
    }
});
